import { Link } from "react-router-dom";
import { useContent } from "@/context/ContentContext";
import { resolveImage } from "@/lib/api";
import WhatsAppIcon from "@/components/WhatsAppIcon";
import { Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  const { content } = useContent();
  const brand = content?.brand || {};
  const contact = content?.contact || {};
  const footer = content?.footer || {};

  const waHref = contact.whatsapp_number
    ? `https://wa.me/${(contact.whatsapp_number || "").replace(/\D/g, "")}`
    : "#";

  return (
    <footer className="bg-tmf-navy text-white mt-24">
      <div className="max-w-7xl mx-auto px-4 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-12 rounded-full overflow-hidden bg-white">
              {brand.logo_url ? (
                <img src={resolveImage(brand.logo_url)} alt="TMF" className="w-full h-full object-cover" />
              ) : (
                <div className="w-full h-full flex items-center justify-center bg-tmf-blue text-white font-display font-black text-lg">T</div>
              )}
            </div>
            <div>
              <div className="font-display font-black text-lg tracking-tight">{brand.name || "TMF"}</div>
              <div className="text-[10px] font-mono-tmf tracking-widest text-slate-300 uppercase">{brand.tagline || "by Silver Sure"}</div>
            </div>
          </div>
          <p className="text-sm text-slate-300 leading-relaxed">
            {footer.tagline || "Factory-direct hospital furniture manufactured by Silver Sure Vending Solutions LLP."}
          </p>
        </div>

        <div>
          <h4 className="font-display font-bold uppercase tracking-widest text-xs mb-4 text-tmf-sky">Shop</h4>
          <ul className="space-y-2 text-sm text-slate-300">
            <li><Link to="/category/icu-beds" className="hover:text-tmf-sky">ICU Beds</Link></li>
            <li><Link to="/category/hospital-beds" className="hover:text-tmf-sky">Hospital Beds</Link></li>
            <li><Link to="/category/ot-tables" className="hover:text-tmf-sky">OT Tables</Link></li>
            <li><Link to="/category/examination-tables" className="hover:text-tmf-sky">Examination Tables</Link></li>
            <li><Link to="/products" className="hover:text-tmf-sky">All Products</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display font-bold uppercase tracking-widest text-xs mb-4 text-tmf-sky">Company</h4>
          <ul className="space-y-2 text-sm text-slate-300">
            <li><Link data-testid="footer-home-link" to="/" className="hover:text-tmf-sky">Home</Link></li>
            <li><Link to="/about" className="hover:text-tmf-sky">About Silver Sure</Link></li>
            <li><Link to="/contact" className="hover:text-tmf-sky">Contact / Bulk Enquiry</Link></li>
            <li><Link to="/account" className="hover:text-tmf-sky">Track Order</Link></li>
            <li><Link data-testid="footer-privacy-link" to="/privacy-policy" className="hover:text-tmf-sky">Privacy Policy</Link></li>
            <li><Link data-testid="footer-terms-link" to="/terms-of-service" className="hover:text-tmf-sky">Terms of Service</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display font-bold uppercase tracking-widest text-xs mb-4 text-tmf-sky">Reach Us</h4>
          <ul className="space-y-3 text-sm text-slate-300">
            <li className="flex gap-3"><Mail size={16} className="text-tmf-sky shrink-0 mt-0.5" /> {contact.email || "sales@tmfsilversure.com"}</li>
            {contact.phone && <li className="flex gap-3"><Phone size={16} className="text-tmf-sky shrink-0 mt-0.5" /> {contact.phone}</li>}
            <li>
              <a href={waHref} target="_blank" rel="noreferrer" className="flex gap-3 hover:text-tmf-sky items-center">
                <WhatsAppIcon size={16} className="text-[#25D366] shrink-0" /> WhatsApp Support
              </a>
            </li>
            <li className="flex gap-3"><MapPin size={16} className="text-tmf-sky shrink-0 mt-0.5" /> {contact.address || "Silver Sure Vending Solutions LLP, India"}</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-slate-700">
        <div className="max-w-7xl mx-auto px-4 py-6 flex flex-col md:flex-row justify-between items-center gap-4 text-xs font-mono-tmf text-slate-400 uppercase tracking-widest">
          <div>© {new Date().getFullYear()} {brand.company || "Silver Sure Vending Solutions LLP"}. All rights reserved.</div>
          <div>GeM-Listed OEM · ISO 13485 · 9001 · CE Certified</div>
        </div>
      </div>
    </footer>
  );
}
